import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './setpoint.routes';
import addHtml from './modal/add.html';

export class SetPointController {
    $http;
    socket;
    awesomeThings = [];
    setpoints = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('setpoint');
        });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            console.log(this.$cookies.get('token'))
            this.$http.get('/api/set_point_exchange/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                }
            })
                .then(response => {
                    console.log(response);
                    if (response.data.data) {
                        this.setpoints = response.data.data;
                        this.socket.syncUpdates('setpoint', this.setpoints);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }



    deleteMultiplication(setpoint, index) {
        this.$http.delete(`/api/set_point_exchange/${setpoint._id}/`).then(response => {
            if (response.status === 200) {
                this.setpoints.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    addMultiplication() {
        const setpoints = this.setpoints;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.Type = [
                    { value: 1, name: '去广告' },
                    { value: 2, name: '听语音' }
                ]
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/set_point_exchange/', $scope.vm).then((response) => {
                            console.log(response.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                console.log(ret);
                if (ret) {
                    setpoints.push(ret);
                }
            }, function () {
            });
    }

    updateMultiplication(setpoint, index) {
        const setpoints = this.setpoints;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.Type = [
                    { value: 1, name: '去广告' },
                    { value: 2, name: '听语音' }
                ]
                $scope.vm = angular.copy(setpoint);
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        $http.put('/api/set_point_exchange/' + setpoint._id + '/', $scope.vm).then((response) => {
                            console.log(response.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                console.log(ret);
                if (ret) {
                    setpoints[index] = ret;
                }
            }, function () {
            });
    }

}

export default angular.module('tttApp.setpoint', [uiRouter])
    .config(routing)
    .component('setpoint', {
        template: require('./setpoint.html'),
        controller: SetPointController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/setpoint/setpoint.component.js